import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useFoundingSpotsRemaining(): number | null {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    supabase.rpc("get_founding_spots_remaining").then(({ data }) => {
      if (typeof data === "number") setCount(data);
    });
  }, []);
  return count;
}
